export const shiftVI = {
  "shiftSider": {
    "headingLabel": "Cài Đặt Ca Làm Việc",
    "information": "Thông Tin Chung",
    "midShiftSettings": "Cài Đặt Giữa Ca",
    "infomation": "Thông tin ca",
    "titleAdd" : "Tạo mới cài đặt ca làm việc",
    "titleUpdate" : "Cập nhật cài đặt ca làm việc",
    "listShift": "Danh sách Ca Làm Việc",
  },
  "shiftTitle": {
    "codeShift": "Mã ca",
    "nameSHift": "Tên ca",
    "flexibleHours": "Giờ linh hoạt",
    "manyShift": "Nhiều khoảng làm việc",
    "timeBreak": "Thời gian nghỉ",
    "endBreak": "Kết thúc nghỉ ",
    "checkInFirst": "Check in trước",
    "checkInLater": "Check out sau",
    "totalHours": "Tổng giờ",
    "totalWork": "Tổng công",
    "status": "Trạng thái",
    "workingCheck": "Tính thời gian đi muộn, về sớm giữa ca",
    "overTime": "Giờ làm thêm giữa ca",
    "midShift": "Bắt buộc chốt giữa ca",
    "checkFirstShift": "Check out cuối ca đầu",
    "checkNextShift": "Check in đầu ca sau",
    "shiftHoliday": "Ca tự động cho ngày nghỉ lễ ",
    "timekeepingAuto": "Chấm công tự động",
    "checkApplyToLocation": "Check out tự động áp dụng cho vị trí",
    "checkByDepartmentLocation": "Tự động nhận biết phòng ban vị trí",
    "noteShift": "Ghi chú",
    "timeIn": "Giờ vào",
    "timeOut": "Giờ ra",
    "byDay": "Qua ngày",
    "yes" : "Có",
    "no" : "Không",
    "department": "Phòng ban",
    "position": "Vị trí",
    "chucvu": "Chức vụ",
    "sbapplication": "Đối tượng áp dụng",
    "checkInFrequency" : "Tính công theo số lần check-in",
    "checkinLabel" : "Số lần tối thiểu cần check-in",
    "checkinLabelRequire" : "Số lần tối thiểu cần check-in là trường bắt buộc!",
    "checkinLabelPlaceholder" : "Nhập số lần tối thiểu cần check-in",
    "timeBetweenCheckIn" : "Thời gian giữa các lần check-in",
    "attendancePercentage" : "Tính % công theo số lần check-in",
    "attendancePercentageToolTip" : "Ví dụ cài đặt tối thiểu 4 lần check-in .NV check-in 2 lần tổng công là 1 => số công thực tế của NV là 0.5",
    "timekeepingAutoToolTip" : "Khi Bật: những nhân viên được phân ca này sẽ được tự động chấm công.",
    "checkApplyToLocationToolTip" : "Khi bật chức năng này nhân viên không cần checkout khi kết thúc ca ."

  },
  "shiftMenu": {
    "addShift": "Thêm mới Ca Làm Viêc",
    "editShift": "Cập nhật Ca Làm Việc",
    "deleteShift": "Xóa Ca Làm Việc"
  }
}
